export const placeCaretAfterChip = (chip: HTMLElement): void => {
  const afterChip = chip.nextSibling;
  const selection = window.getSelection();
  const after = document.createRange();
  if (afterChip?.nodeType === Node.TEXT_NODE) {
    const offset = afterChip.nodeValue?.startsWith('\u00a0') ? 1 : 0;
    after.setStart(afterChip, offset);
  } else {
    after.setStartAfter(chip);
  }
  after.collapse(true);
  selection?.removeAllRanges();
  selection?.addRange(after);
};
